import { createFileRoute } from '@tanstack/react-router'
import { pageTitle } from '@/lib/page-title'
import { AccessSection } from './-components/access-section'
import { EmailSection } from './-components/email-section'
import { PasswordSection } from './-components/password-section'
import { ProfileHeader } from './-components/profile-header'
import { SessionsSection } from './-components/sessions-section'

export const Route = createFileRoute('/(private)/profile/')({
	head: ({ match }) => ({
		meta: [
			{
				title: pageTitle(match.context.appLanguage, 'profile:title')
			}
		]
	}),
	staticData: {
		breadcrumb: 'profile:title'
	},
	component: ProfilePage
})

// One page for the whole profile: who you are, how you access, and the
// security settings. The breadcrumb already says "Profilo", so no title.
function ProfilePage() {
	return (
		<main className='flex min-h-0 flex-1 flex-col gap-8 overflow-y-auto p-4 md:p-6'>
			<ProfileHeader />
			<AccessSection />
			<EmailSection />
			<PasswordSection />
			<SessionsSection />
		</main>
	)
}
